import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/stores/auth";

// Views
const Login = () => import("@/views/Login.vue");
const Dashboard = () => import("@/views/Dashboard.vue");
const ClientDashboard = () => import("@/views/ClientDashboard.vue");
const ClientHome = () => import("@/views/ClientHome.vue");
const ContentManager = () => import("@/views/ContentManager.vue");
const ContentEditor = () => import("@/views/ContentEditor.vue");
const ImageLibrary = () => import("@/views/ImageLibrary.vue");
const Settings = () => import("@/views/Settings.vue");
const RevisionHistory = () => import("@/views/RevisionHistory.vue");

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/:clientSlug",
    component: ClientDashboard, // Wrapper with Sidebar
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "ClientHome",
        component: ClientHome,
      },
      {
        path: "content",
        name: "ContentList",
        component: ContentManager,
      },
      {
        path: "content/new",
        name: "NewContent",
        component: ContentEditor,
      },
      {
        path: "content/:contentSlug",
        name: "EditContent",
        component: ContentEditor,
        props: true,
      },
      {
        path: "images",
        name: "Images",
        component: ImageLibrary,
      },
      {
        path: "settings",
        name: "Settings",
        component: Settings,
      },
      {
        path: "revisions/:contentSlug",
        name: "Revisions",
        component: RevisionHistory,
        props: true,
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/dashboard",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // Check session on first load or route change if not present
  if (!authStore.session) {
    await authStore.checkSession();
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !authStore.isAuthenticated) {
    next({ name: "Login" });
  } else if (to.name === "Login" && authStore.isAuthenticated) {
    next({ name: "Dashboard" });
  } else {
    next();
  }
});

export default router;
